import React, { useEffect, useRef, useState } from 'react'
import Left_panel from '../Left_panel'
import Sub_header from '../Sub_header'
import axios from 'axios'
import exportValue from '../../apiconfig'
import Swal from 'sweetalert2'
import Modal from 'react-bootstrap/Modal';
import ReactLoading from 'react-loading';
import Moment from 'react-moment';
import moment from 'moment';

import '../../components/loader.css';
import TablePagination from '@mui/material/TablePagination';
import { Container, Row, Col, Form, Button, ProgressBar } from "react-bootstrap"
import { useNavigate, useParams } from 'react-router-dom'
import download from 'downloadjs'
import { DateRangePicker } from 'react-date-range';
import { addDays } from "date-fns";
import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css';
import { PDFDocument, rgb } from "pdf-lib";
const International_action_2 = () => {
  const { invoice_id } = useParams();
  console.log("invoice_id == ", invoice_id)
  const [state, setState] = React.useState([])
  const [hubstate, sethubState] = React.useState([])
  const [loader, setloader] = React.useState(false)
  const [isSidebarOpen, setIsSidebarOpen] = React.useState(false);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
    const homeSection = document.querySelector('.home-section');
    if (homeSection) {
      homeSection.classList.toggle('sidebar-closed');
    }
  };

  React.useEffect(() => {
    shipment_tracking()
    dropHub()
  }, [])
  const shipment_tracking = () => {

    let full_api = exportValue.host + "/" + exportValue.version + "/" + exportValue.api + `/shipment_detail_int`;
    let sendData = { shipment_id: invoice_id };
    console.log("bb", sendData);
    axios.post(full_api, sendData, { headers: exportValue.headers }).then((res) => {
      console.log("res -> ", res);
      if (res.data.status == 200) {
        setState(res.data.output)
      }
      else {

      }


    }).catch((e) => {
      // toast.configure()
      //toast.error("Some thing went wrong")
      // console.log("----error:   ", e);
    })
  }

  const dropHub = () => {

    let full_api = exportValue.host + "/" + exportValue.version + "/" + exportValue.api + `/available_drop_hub`;
    let sendData = { shipment_id: invoice_id };
    // console.log("sendData",sendData)

    axios.post(full_api, sendData, { headers: exportValue.headers }).then(res => {
      if (res.data.status == true) {
        sethubState(res.data.output)
      }
      else {

      }


    }).catch((e) => {
      // toast.configure()
      //toast.error("Some thing went wrong")
      // console.log("----error:   ", e);
    })
  }

  const shipping_label = async (wbn) => {
    try {
      setloader(true)
      let full_api = exportValue.apiUrl + `/shipment/download_label`;
      let sendData = { wbn: wbn }
      const response = await axios.post(full_api, sendData, { headers: exportValue.headers }, { responseType: "blob" })
      const response_pdf = response.data.packages[0].pdf_download_link
      console.log("response_pdf===", response_pdf)
      if (response_pdf) {
        setloader(false)
        // Open PDF in a new tab
        window.open(response_pdf, "_blank");

        // OR force download
        // const link = document.createElement("a");
        // link.href = response_pdf;
        // link.setAttribute("download", `Delhivery_Label_${wbn}.pdf`);
        // document.body.appendChild(link);
        // link.click();
        // document.body.removeChild(link);
      } else {
        setloader(false)
        console.error("PDF URL not found in response.");
      }
    } catch (error) {
      setloader(false)
      console.error("Error downloading the label:", error);
    }
  };

  const downloadKycDocuments = async () => {
    const files = [];
    if (state[0]?.shipper_kyc_document_1) {
      files.push(state[0].shipper_kyc_document_1);
    }
    if (state[0]?.shipper_kyc_document_2) {
      files.push(state[0].shipper_kyc_document_2);
    }


    if (files.length === 0) {
      alert("No KYC document available");
      return;
    }

    try {
      console.log("Fetching images from:", files);

      const pdfDoc = await PDFDocument.create();

      for (const fileUrl of files) {
        console.log("Fetching:", fileUrl);
        const response = await fetch(fileUrl);

        if (!response.ok) {
          console.error("Failed to fetch:", fileUrl);
          alert("Error fetching image: " + fileUrl);
          return;
        }

        const imageBytes = await response.arrayBuffer();
        console.log("Image downloaded successfully:", fileUrl);

        let image;
        try {
          image = await pdfDoc.embedJpg(imageBytes);
        } catch (jpgError) {
          console.warn("JPG failed, trying PNG:", jpgError);
          image = await pdfDoc.embedPng(imageBytes);
        }

        const page = pdfDoc.addPage([image.width, image.height]);
        page.drawImage(image, {
          x: 0,
          y: 0,
          width: image.width,
          height: image.height,
        });
      }

      const pdfBytes = await pdfDoc.save();
      const blob = new Blob([pdfBytes], { type: "application/pdf" });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = "Sender_KYC_Documents.pdf";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Error creating PDF:", error);
      alert("Failed to generate PDF.");
    }
  };


  const downloadKycReceiverDocuments = async () => {
    const files = [];
    if (state[0]?.consignee_kyc_document_1) {
      files.push(state[0].consignee_kyc_document_1);
    }
    if (state[0]?.consignee_kyc_document_2) {
      files.push(state[0].consignee_kyc_document_2);
    }


    if (files.length === 0) {
      // alert("No KYC document available");
      return;
    }

    try {
      console.log("Fetching images from:", files);

      const pdfDoc = await PDFDocument.create();

      for (const fileUrl of files) {
        console.log("Fetching:", fileUrl);
        const response = await fetch(fileUrl);

        if (!response.ok) {
          console.error("Failed to fetch:", fileUrl);
          alert("Error fetching image: " + fileUrl);
          return;
        }

        const imageBytes = await response.arrayBuffer();
        console.log("Image downloaded successfully:", fileUrl);

        let image;
        try {
          image = await pdfDoc.embedJpg(imageBytes);
        } catch (jpgError) {
          console.warn("JPG failed, trying PNG:", jpgError);
          image = await pdfDoc.embedPng(imageBytes);
        }

        const page = pdfDoc.addPage([image.width, image.height]);
        page.drawImage(image, {
          x: 0,
          y: 0,
          width: image.width,
          height: image.height,
        });
      }

      const pdfBytes = await pdfDoc.save();
      const blob = new Blob([pdfBytes], { type: "application/pdf" });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = "Receiver_KYC_Documents.pdf";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Error creating PDF:", error);
      alert("Failed to generate PDF.");
    }
  };

  const openPdf = (pdf) => {
    let pdfWindow = window.open("")
    pdfWindow.document.write(
      "<iframe width='100%' height='100%' src='data:application/pdf;base64, " +
      encodeURI(pdf) + "'></iframe>"
    )
  }

  return (
    <div>

      <Left_panel isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />

      <section class="home-section">

        <Sub_header />


        <div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center">
          <div class="d-block mb-4 mb-md-0">
            <div class="d-flex back_btn_wrap">
              {/* <a href="javascript:window.history.back();" class="back_btn"><i class="fa fa-long-arrow-left"></i></a> */}
              <a href="javascript:window.history.back();" class="back_btn"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" data-lucide="corner-up-left" class="lucide lucide-corner-up-left"><polyline points="9 14 4 9 9 4"></polyline><path d="M20 20v-7a4 4 0 0 0-4-4H4"></path></svg></a>
              <h2>{state.length > 0 ? state[0].carrier_tracking_number : ""}</h2>
            </div>
          </div>
        </div>



        <div class="row justify-content-center">
          {state.length > 0 ?
            <>
              {state[0].int_action == "Self Ship" ?
                <div class="col-12 col-md-6">
                  <div class="card border-0 mb-3">
                    <div class="card-body">
                      <div class="alert alert-success">
                        <strong>Success!</strong> Your shipment is booked as <strong>Self Ship</strong> mode. Please use the below Hub address details o drop off your shipment. Please download the international shipping label and attach it to the shipment box.
                        <br />
                        Also recommended to print two copies of the invoice and KYC to include with the box.
                      </div>



                      <h4>Mode: <strong class="text-primary">Self Ship</strong></h4>

                      <div class="row mt-4">
                        <div class="col-12 col-md-12 mb-2">
                          <h6>Avaiable Drop Hub</h6>
                          <hr />
                          {hubstate.length > 0 ? <>
                            {hubstate.map((item) => (
                              <>
                                <h6>Address</h6>
                                <p>
                                  {item.hub_address} , {item.hub_city} , {item.hub_state} , {item.hub_pincode}
                                </p>
                                <h6>Mobile Number</h6>
                                <p>
                                  {item.hub_mobile}
                                </p>
                                <h6>Email</h6>
                                <p>
                                  {item.hub_email}
                                </p>
                              </>
                            ))}
                            <small>Note: Please use Hub details in case you need any support.</small>

                          </> : ""}
                          <p>

                          </p>
                        </div>
                        <div class="col-6 col-md-6 mb-2">
                          {state[0].carrier_id == "1737462194" ? <a href={`${state[0].shipping_label}`} class="btn btn-primary" target='_blank'><i class="bi bi-download"></i> Download International Label</a> : state[0].carrier_id == "1746785218" ? <button onClick={() => openPdf(state[0].shipping_label)} class="btn btn-primary" target='_blank'><i class="bi bi-download"></i> Download International Label</button> : state[0].carrier_id == "1747222584" ? <button onClick={() => openPdf(state[0].shipping_label)} class="btn btn-primary" ><i class="bi bi-download"></i> Download International Label</button> : state[0].carrier_id == "1746708024" ? <button onClick={() => openPdf(state[0].shipping_label)} class="btn btn-primary" ><i class="bi bi-download"></i> Download International Label</button> : ""}
                        </div>
                        <div class="col-6 col-md-6 mb-2">
                          {state[0].shipper_kyc_document_1 != "" || state[0].shipper_kyc_document_2 != "" ? <a className="btn btn-primary" onClick={downloadKycDocuments}> <i className="bi bi-download"></i> Download Sender KYC</a> : ""}
                        </div>
                        <div class="col-6 col-md-6 mb-2">
                          {state[0].consignee_kyc_document_1 != "" || state[0].consignee_kyc_document_1 != "" ? <a onClick={downloadKycReceiverDocuments} class="btn btn-primary"><i class="bi bi-download"></i> Download Receiver KYC</a> : ""}
                        </div>
                      </div>


                    </div>
                  </div>
                </div>

                :

                state.length > 0 ?
                  <div class="col-12 col-md-6">
                    <div class="card border-0 mb-3">
                      <div class="card-body">
                        {state[0].int_action_process == 0 ?
                          <div class="alert alert-warning">
                            <strong>Processing!</strong> Shipment is under creation. Please wait.
                          </div>
                          : state[0].int_action_process == 2 ?
                            <div class="alert alert-danger">
                              <strong>Error!</strong> Something went wrong. Please contact our support team for futher help.
                            </div>
                            :
                            <div class="alert alert-success">
                              <strong>Success!</strong> Your shipment is booked with door pickup. The AWB number is <strong>{state[0].local_awb}.</strong> Please download both the pickup and international shipping labels and attach them to the shipment box. The shipment will be picked up soon from your doorstep.<br />
                              Also recommended to print two copies of the invoice and KYC to include with the box.
                            </div>

                        }

                        <div class="row mt-4">
                          <div class="col-6 col-md-4 mb-2">
                            <small class="text-muted">Order on</small>
                            <p><a href=""><Moment format="MMM DD YYYY">
                              {new Date(state[0].created * 1000)}
                            </Moment> - <Moment format="hh:mm:ss a">
                                {new Date(state[0].created * 1000)}
                              </Moment></a></p>
                          </div>
                          <div class="col-6 col-md-4 mb-2">
                            <small class="text-muted">Shipping Courier</small>
                            <p>Delhivery</p>
                          </div>
                          <div class="col-6 col-md-4 mb-2">
                            <small class="text-muted">Shipping Courier AWB No.</small>
                            <p><a href="">{state[0].local_awb}</a></p>
                          </div>
                          <div class="col-6 col-md-6 mb-2">
                            {loader == false ? <a onClick={(e) => shipping_label(state[0].local_awb)} class="btn btn-primary"><i class="bi bi-download"></i> Download Pickup Label</a> : <ReactLoading type={"spin"} color={"#0d6efd"} height={40} width={60} />}
                          </div>
                          <div class="col-6 col-md-6 mb-2">
                            {state[0].carrier_id == "1737462194" ? <a href={`${state[0].shipping_label}`} class="btn btn-primary" target='_blank'><i class="bi bi-download"></i> Download International Label</a> : state[0].carrier_id == "1746785218" ? <button onClick={() => openPdf(state[0].shipping_label)} class="btn btn-primary" target='_blank'><i class="bi bi-download"></i> Download International Label</button> : state[0].carrier_id == "1747222584" ? <button onClick={() => openPdf(state[0].shipping_label)} class="btn btn-primary" ><i class="bi bi-download"></i> Download International Label</button> : state[0].carrier_id == "1746708024" ? <button onClick={() => openPdf(state[0].shipping_label)} class="btn btn-primary" ><i class="bi bi-download"></i> Download International Label</button> : ""}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  : ""
              }</> : ""}

        </div>



      </section>


    </div>
  )
}

export default International_action_2
